// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#section {
  background-image: var(--img);
  background-size: contain;
  background-position: left;
  background-repeat: no-repeat;
  position: relative;
}

.contacts__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  height: 76svh;
  position: static;
  color: white;
  justify-items: left;
  align-items: center;
  z-index: 101;
}

.contacts__contacts__Grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 80%;
  position: relative;
  top: 2.25em;
  left: -1.5em;
}

.contacts__left__items {
  max-width: -moz-fit-content;
  max-width: fit-content;
  grid-column-start: 2;
  width: 50%;
  justify-self: left;
  position: relative;
  top: 0;
  left: 8em;
}

.contacts__middle__items {
  max-width: -moz-fit-content;
  max-width: fit-content;
  grid-column-start: 3;
  width: 70%;
  position: relative;
  top: 0;
  left: 6em;
}

.contacts__right__items {
  max-width: -moz-fit-content;
  max-width: fit-content;
  grid-column-start: 4;
  position: relative;
  top: 1.2em;
  left: 1em;
}

.contacts__Grid h1 {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 2em;
}

.contacts__Grid p {
  font-size: 18px;
  font-weight: normal;
}

.contacts__Grid img {
  padding-bottom: 1em;
}

.grid-container__footer__contacts {
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  margin-top: 7.5em;
  padding-bottom: 2.5em;
  color: white;
  position: sticky;
  top: 100%;
  left: 15.7%;
}

.footer__logos__test__contacts {
  grid-column: 1 / 2;
  display: flex;
  width: clamp(150px, 100%, 100%);
  align-items: end;
  justify-content: left;
  gap: 2em;
}

.footer__links__test__contacts {
  grid-column: 2 / 3;
  display: flex;
  justify-content: space-between;
  width: clamp(150px, 100%, 100%);
  align-items: end;
}

.footer__links__test__contacts p {
  font-size: 18px;
  opacity: 50%;
}

.grid-container__footer__contacts div {
  display: flex;
  align-items: last baseline;
}

.footer__logos__test__contacts img {
  max-height: 34px;
  width: 95%;
}

.grid-container__footer__mobile__contacts {
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  grid-gap: 10px;
  margin: 0 auto;
  padding: 1em 0 1em 0;
  width: 89.5%;
  color: white;
  position: fixed;
  bottom: 1em;
  left: 5%;
}

.footer__mobile__contacts__img {
  max-height: 34.0333px;
}

.contacts__contacts__item__mobile {
  display: grid;
  align-items: center;
}

.contacts__contacts__item__mobile p {
  justify-self: left;
}

.contacts__Grid__mobile {
  display: none;
}

.grid-container__footer__mobile__contacts {
  display: none;
}

@media all and (min-width: 1921px) {
  .contacts__Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 68.6%;
    height: 76svh;
    position: relative;
    left: 0;
    top: 7.5%;
    color: white;
    justify-items: right;
    align-items: center;
    z-index: 101;
  }

  .contacts__items__grid {
    grid-column: 2 / 5;
    gap: 30px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    max-width: 80%;
    justify-content: left;
    align-items: start;
    position: relative;
    left: 6%;
  }

  .contacts__contacts__Grid {
    display: inline-grid;
    grid-template-columns: auto auto auto;
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 80%;
    position: static;
  }

  .contacts__left__items {
    max-width: -moz-fit-content;
    max-width: fit-content;
    grid-column-start: 1;
    width: 100%;
    justify-self: right;
    position: static;
  }

  .contacts__middle__items {
    max-width: -moz-fit-content;
    max-width: fit-content;
    grid-column-start: 2;
    width: 100%;
    position: static;
  }

  .contacts__right__items {
    max-width: -moz-fit-content;
    max-width: fit-content;
    grid-column-start: 3;
    position: static;
  }

  .contacts__Grid h1 {
    font-size: 17px;
    font-weight: bold;
    padding-bottom: 2em;
  }

  .contacts__right__items h1 {
    font-size: 17px;
    font-weight: bold;
    padding-bottom: 2em;
  }

  .contacts__Grid p {
    font-size: 17px;
    font-weight: normal;
  }

  .contacts__Grid img {
    padding-bottom: 1em;
  }

  .grid-container__footer__contacts {
    display: grid;
    grid-template-columns: repeat(2, minmax(320px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 68.6%;
    color: white;
    position: static;
    z-index: 100;
    bottom: 0;
    left: 15.7%;
  }
}

@media all and (min-width: 1441px) and (max-width: 1920px) {
  .contacts__Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 68.6%;
    height: 75%;
    position: relative;
    left: 0;
    top: 7.5%;
    color: white;
    justify-items: right;
    align-items: center;
    z-index: 101;
  }

  .contacts__items__grid {
    grid-column: 2 / 5;
    gap: 10px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    max-width: 80%;
    justify-content: left;
    align-items: start;
  }

  .contacts__contacts__Grid {
    display: inline-grid;
    grid-template-columns: auto auto auto;
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 80%;
    position: static;
  }

  .contacts__left__items {
    max-width: -moz-fit-content;
    max-width: fit-content;
    grid-column-start: 1;
    width: 100%;
    justify-self: right;
    position: static;
  }

  .contacts__middle__items {
    max-width: -moz-fit-content;
    max-width: fit-content;
    grid-column-start: 2;
    width: 100%;
    position: static;
  }

  .contacts__right__items {
    max-width: -moz-fit-content;
    max-width: fit-content;
    grid-column-start: 3;
    position: static;
  }

  .contacts__Grid h1 {
    font-size: 17px;
    font-weight: bold;
    padding-bottom: 2em;
  }

  .contacts__right__items h1 {
    font-size: 17px;
    font-weight: bold;
    padding-bottom: 2em;
  }

  .contacts__Grid p {
    font-size: 17px;
    font-weight: normal;
  }

  .contacts__Grid img {
    padding-bottom: 1em;
  }

  .grid-container__footer__contacts {
    display: grid;
    grid-template-columns: repeat(2, minmax(320px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 68.6%;
    color: white;
    position: static;
    z-index: 100;
    bottom: 0;
    left: 15.7%;
  }
}

@media all and (min-width: 1025px) and (max-width: 1440px) {
  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    gap: 20px;
    margin: 0 auto;
    padding: 0;
    padding-top: 0px;
    padding-top: 2.5em;
    align-content: center;
    align-items: end;
    position: sticky;
    top: 0;
    z-index: 2;
    max-width: 80% !important;
  }

  .contacts__Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 80%;
    height: 75%;
    position: relative;
    left: 0;
    top: 7.5%;
    color: white;
    justify-items: right;
    align-items: center;
    z-index: 101;
  }

  .contacts__items__grid {
    grid-column: 2 / 5;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(3, 1fr);
    max-width: 80%;
    justify-content: left;
    align-items: start;
  }

  .contacts__contacts__Grid {
    display: inline-grid;
    grid-template-columns: auto auto auto;
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    position: static;
  }

  .contacts__left__items {
    max-width: 100%;
    grid-column-start: 1;
    width: 100%;
    justify-self: right;
    position: static;
  }

  .contacts__middle__items {
    max-width: 100%;
    grid-column-start: 2;
    width: 100%;
    position: static;
  }

  .contacts__right__items {
    max-width: -moz-fit-content;
    max-width: fit-content;
    grid-column-start: 3;
    position: static;
  }

  .contacts__Grid h1 {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 2em;
  }

  .contacts__right__items h1 {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 2em;
  }

  .contacts__Grid p {
    font-size: 16px;
    font-weight: normal;
  }

  .contacts__Grid img {
    padding-bottom: 1em;
  }

  .grid-container__footer__contacts {
    display: grid;
    grid-template-columns: repeat(2, minmax(320px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 80%;
    color: white;
    position: static;
    z-index: 100;
  }
}

@media all and (min-width: 769px) and (max-width: 1024px) {
  #section {
    background-image: var(--img);
    background-size: contain;
    background-position: bottom left;
    background-repeat: no-repeat;
    position: relative;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid {
    display: none;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid__mobile {
    display: grid;
  }

  .menu__mobile__right {
    align-items: end;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
  }

  .contacts__Grid__mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    margin-top: 2.5em;
    padding-bottom: 2.5em;
    color: white;
    justify-content: left;
    position: relative;
    z-index: 101;
  }

  .contacts__mobile__test {
    grid-column: 1 / 3;
    justify-content: space-between;
  }

  .contacts__Grid__mobile h1 {
    font-size: 12px;
    font-weight: bold;
  }

  .contacts__Grid__mobile p {
    font-size: 12px;
    font-weight: normal;
  }

  .contacts__Mobile__icons {
    grid-column: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .contacts__Mobile__icons h1 {
    margin-right: 1em;
  }

  .contacts__Mobile__icons img {
    justify-self: end;
  }

  .contacts__left__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__middle__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__right__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    min-width: 100%;
  }

  .contacts__contacts__item__mobile__left {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .contacts__contacts__item__mobile__left h1 {
    position: relative;
  }

  .yaya {
    justify-self: right;
  }
  .yaya img {
    padding: 0.5em 0 0.5em 0;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 1em 0 1em 0;
    width: 89.5%;
    color: white;
    position: fixed;
    bottom: 1em;
    left: 5%;
  }

  .footer__mobile__contacts__img {
    max-height: 34.0333px;
  }

  .contacts__contacts__item__mobile {
    display: grid;
    align-items: center;
  }

  .contacts__contacts__item__mobile p {
    justify-self: left;
  }
}

@media all and (min-width: 426px) and (max-width: 768px) {
  #section {
    background-image: var(--img);
    background-size: contain;
    background-position: bottom left;
    background-repeat: no-repeat;
    position: relative;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid {
    display: none;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid__mobile {
    display: grid;
  }

  .menu__mobile__right {
    align-items: end;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
  }

  .contacts__Grid__mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    margin-top: 2.5em;
    padding-bottom: 2.5em;
    color: white;
    justify-content: left;
    position: relative;
    z-index: 101;
  }

  .contacts__mobile__test {
    grid-column: 1 / 3;
    justify-content: space-between;
  }

  .contacts__Grid__mobile h1 {
    font-size: 12px;
    font-weight: bold;
  }

  .contacts__Grid__mobile p {
    font-size: 12px;
    font-weight: normal;
  }

  .contacts__Mobile__icons {
    grid-column: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .contacts__Mobile__icons h1 {
    margin-right: 1em;
  }

  .contacts__Mobile__icons img {
    justify-self: end;
  }

  .contacts__left__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__middle__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__right__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    min-width: 100%;
  }

  .contacts__contacts__item__mobile__left {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .contacts__contacts__item__mobile__left h1 {
    position: relative;
  }

  .yaya {
    justify-self: right;
  }
  .yaya img {
    padding: 0.5em 0 0.5em 0;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 1em 0 1em 0;
    width: 89.5%;
    color: white;
    position: fixed;
    bottom: 1em;
    left: 5%;
  }

  .footer__mobile__contacts__img {
    max-height: 34.0333px;
  }

  .contacts__contacts__item__mobile {
    display: grid;
    align-items: center;
  }

  .contacts__contacts__item__mobile p {
    justify-self: left;
  }
}

@media all and (min-width: 376px) and (max-width: 425px) {
  #section {
    background-image: var(--img);
    background-size: contain;
    background-position: bottom left;
    background-repeat: no-repeat;
    position: relative;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid {
    display: none;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid__mobile {
    display: grid;
  }

  .menu__mobile__right {
    align-items: end;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
  }

  .contacts__Grid__mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    margin-top: 2.5em;
    padding-bottom: 2.5em;
    color: white;
    justify-content: left;
    position: relative;
    z-index: 101;
  }

  .contacts__mobile__test {
    grid-column: 1 / 3;
    justify-content: space-between;
  }

  .contacts__Grid__mobile h1 {
    font-size: 12px;
    font-weight: bold;
  }

  .contacts__Grid__mobile p {
    font-size: 12px;
    font-weight: normal;
  }

  .contacts__Mobile__icons {
    grid-column: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .contacts__Mobile__icons h1 {
    margin-right: 1em;
  }

  .contacts__Mobile__icons img {
    justify-self: end;
  }

  .contacts__left__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__middle__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__right__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    min-width: 100%;
  }

  .contacts__contacts__item__mobile__left {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .contacts__contacts__item__mobile__left h1 {
    position: relative;
  }

  .yaya {
    justify-self: right;
  }
  .yaya img {
    padding: 0.5em 0 0.5em 0;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 1em 0 1em 0;
    width: 89.5%;
    color: white;
    position: fixed;
    bottom: 1em;
    left: 5%;
  }

  .footer__mobile__contacts__img {
    max-height: 34.0333px;
  }

  .contacts__contacts__item__mobile {
    display: grid;
    align-items: center;
  }

  .contacts__contacts__item__mobile p {
    justify-self: left;
  }
}

@media all and (min-width: 321px) and (max-width: 375px) {
  #section {
    background-image: var(--img);
    background-size: contain;
    background-position: bottom left;
    background-repeat: no-repeat;
    position: relative;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid {
    display: none;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid__mobile {
    display: grid;
  }

  .menu__mobile__right {
    align-items: end;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
  }

  .contacts__Grid__mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    margin-top: 2.5em;
    padding-bottom: 2.5em;
    color: white;
    justify-content: left;
    position: relative;
    z-index: 101;
  }

  .contacts__mobile__test {
    grid-column: 1 / 3;
    justify-content: space-between;
  }

  .contacts__Grid__mobile h1 {
    font-size: 12px;
    font-weight: bold;
  }

  .contacts__Grid__mobile p {
    font-size: 12px;
    font-weight: normal;
  }

  .contacts__Mobile__icons {
    grid-column: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .contacts__Mobile__icons h1 {
    margin-right: 1em;
  }

  .contacts__Mobile__icons img {
    justify-self: end;
  }

  .contacts__left__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__middle__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__right__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    min-width: 100%;
  }

  .contacts__contacts__item__mobile__left {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .contacts__contacts__item__mobile__left h1 {
    position: relative;
  }

  .yaya {
    justify-self: right;
  }
  .yaya img {
    padding: 0.5em 0 0.5em 0;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 1em 0 1em 0;
    width: 89.5%;
    color: white;
    position: fixed;
    bottom: 1em;
    left: 5%;
  }

  .footer__mobile__contacts__img {
    max-height: 34.0333px;
  }

  .contacts__contacts__item__mobile {
    display: grid;
    align-items: center;
  }

  .contacts__contacts__item__mobile p {
    justify-self: left;
  }
}

@media all and (max-width: 320px) {
  #section {
    background-image: var(--img);
    background-size: contain;
    background-position: bottom left;
    background-repeat: no-repeat;
    position: relative;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid {
    display: none;
  }

  .grid-container__footer__contacts {
    display: none;
  }

  .contacts__Grid__mobile {
    display: grid;
  }

  .menu__mobile__right {
    align-items: end;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
  }

  .contacts__Grid__mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    margin-top: 2.5em;
    padding-bottom: 2.5em;
    color: white;
    justify-content: left;
    position: relative;
    z-index: 101;
  }

  .contacts__mobile__test {
    grid-column: 1 / 3;
    justify-content: space-between;
  }

  .contacts__Grid__mobile h1 {
    font-size: 12px;
    font-weight: bold;
  }

  .contacts__Grid__mobile p {
    font-size: 12px;
    font-weight: normal;
  }

  .contacts__Mobile__icons {
    grid-column: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .contacts__Mobile__icons h1 {
    margin-right: 1em;
  }

  .contacts__Mobile__icons img {
    justify-self: end;
  }

  .contacts__left__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__middle__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 100%;
    padding-bottom: 2.5em;
    position: relative;
    left: 0;
  }

  .contacts__left__items__mobile img {
    justify-self: end;
  }

  .contacts__left__items__mobile p {
    justify-self: left;
    grid-column: 2 / 3 !important;
  }

  .contacts__right__items__mobile {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    min-width: 100%;
  }

  .contacts__contacts__item__mobile__left {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .contacts__contacts__item__mobile__left h1 {
    position: relative;
  }

  .yaya {
    justify-self: right;
  }
  .yaya img {
    padding: 0.5em 0 0.5em 0;
  }

  .grid-container__footer__mobile__contacts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 1em 0 1em 0;
    width: 89.5%;
    color: white;
    position: fixed;
    bottom: 1em;
    left: 5%;
  }

  .footer__mobile__contacts__img {
    max-height: 34.0333px;
  }

  .contacts__contacts__item__mobile {
    display: grid;
    align-items: center;
  }

  .contacts__contacts__item__mobile p {
    justify-self: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Contacts.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,cAAc;EACd,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,qCAAqC;IACrC,cAAc;IACd,cAAc;IACd,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,qCAAqC;IACrC,cAAc;IACd,cAAc;IACd,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,qCAAqC;IACrC,cAAc;IACd,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,qCAAqC;IACrC,cAAc;IACd,cAAc;IACd,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IAErB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["#section {\r\n  background-image: var(--img);\r\n  background-size: contain;\r\n  background-position: left;\r\n  background-repeat: no-repeat;\r\n  position: relative;\r\n}\r\n\r\n.contacts__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  height: 76svh;\r\n  position: static;\r\n  color: white;\r\n  justify-items: left;\r\n  align-items: center;\r\n  z-index: 101;\r\n}\r\n\r\n.contacts__contacts__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 80%;\r\n  position: relative;\r\n  top: 2.25em;\r\n  left: -1.5em;\r\n}\r\n\r\n.contacts__left__items {\r\n  max-width: fit-content;\r\n  grid-column-start: 2;\r\n  width: 50%;\r\n  justify-self: left;\r\n  position: relative;\r\n  top: 0;\r\n  left: 8em;\r\n}\r\n\r\n.contacts__middle__items {\r\n  max-width: fit-content;\r\n  grid-column-start: 3;\r\n  width: 70%;\r\n  position: relative;\r\n  top: 0;\r\n  left: 6em;\r\n}\r\n\r\n.contacts__right__items {\r\n  max-width: fit-content;\r\n  grid-column-start: 4;\r\n  position: relative;\r\n  top: 1.2em;\r\n  left: 1em;\r\n}\r\n\r\n.contacts__Grid h1 {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding-bottom: 2em;\r\n}\r\n\r\n.contacts__Grid p {\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n}\r\n\r\n.contacts__Grid img {\r\n  padding-bottom: 1em;\r\n}\r\n\r\n.grid-container__footer__contacts {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(320px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  margin-top: 7.5em;\r\n  padding-bottom: 2.5em;\r\n  color: white;\r\n  position: sticky;\r\n  top: 100%;\r\n  left: 15.7%;\r\n}\r\n\r\n.footer__logos__test__contacts {\r\n  grid-column: 1 / 2;\r\n  display: flex;\r\n  width: clamp(150px, 100%, 100%);\r\n  align-items: end;\r\n  justify-content: left;\r\n  gap: 2em;\r\n}\r\n\r\n.footer__links__test__contacts {\r\n  grid-column: 2 / 3;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: clamp(150px, 100%, 100%);\r\n  align-items: end;\r\n}\r\n\r\n.footer__links__test__contacts p {\r\n  font-size: 18px;\r\n  opacity: 50%;\r\n}\r\n\r\n.grid-container__footer__contacts div {\r\n  display: flex;\r\n  align-items: last baseline;\r\n}\r\n\r\n.footer__logos__test__contacts img {\r\n  max-height: 34px;\r\n  width: 95%;\r\n}\r\n\r\n.grid-container__footer__mobile__contacts {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n  grid-gap: 10px;\r\n  margin: 0 auto;\r\n  padding: 1em 0 1em 0;\r\n  width: 89.5%;\r\n  color: white;\r\n  position: fixed;\r\n  bottom: 1em;\r\n  left: 5%;\r\n}\r\n\r\n.footer__mobile__contacts__img {\r\n  max-height: 34.0333px;\r\n}\r\n\r\n.contacts__contacts__item__mobile {\r\n  display: grid;\r\n  align-items: center;\r\n}\r\n\r\n.contacts__contacts__item__mobile p {\r\n  justify-self: left;\r\n}\r\n\r\n.contacts__Grid__mobile {\r\n  display: none;\r\n}\r\n\r\n.grid-container__footer__mobile__contacts {\r\n  display: none;\r\n}\r\n\r\n@media all and (min-width: 1921px) {\r\n  .contacts__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 68.6%;\r\n    height: 76svh;\r\n    position: relative;\r\n    left: 0;\r\n    top: 7.5%;\r\n    color: white;\r\n    justify-items: right;\r\n    align-items: center;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__items__grid {\r\n    grid-column: 2 / 5;\r\n    gap: 30px;\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    max-width: 80%;\r\n    justify-content: left;\r\n    align-items: start;\r\n    position: relative;\r\n    left: 6%;\r\n  }\r\n\r\n  .contacts__contacts__Grid {\r\n    display: inline-grid;\r\n    grid-template-columns: auto auto auto;\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 80%;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__left__items {\r\n    max-width: fit-content;\r\n    grid-column-start: 1;\r\n    width: 100%;\r\n    justify-self: right;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__middle__items {\r\n    max-width: fit-content;\r\n    grid-column-start: 2;\r\n    width: 100%;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__right__items {\r\n    max-width: fit-content;\r\n    grid-column-start: 3;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__Grid h1 {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .contacts__right__items h1 {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .contacts__Grid p {\r\n    font-size: 17px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Grid img {\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(320px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 68.6%;\r\n    color: white;\r\n    position: static;\r\n    z-index: 100;\r\n    bottom: 0;\r\n    left: 15.7%;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1441px) and (max-width: 1920px) {\r\n  .contacts__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 68.6%;\r\n    height: 75%;\r\n    position: relative;\r\n    left: 0;\r\n    top: 7.5%;\r\n    color: white;\r\n    justify-items: right;\r\n    align-items: center;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__items__grid {\r\n    grid-column: 2 / 5;\r\n    gap: 10px;\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    max-width: 80%;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .contacts__contacts__Grid {\r\n    display: inline-grid;\r\n    grid-template-columns: auto auto auto;\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 80%;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__left__items {\r\n    max-width: fit-content;\r\n    grid-column-start: 1;\r\n    width: 100%;\r\n    justify-self: right;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__middle__items {\r\n    max-width: fit-content;\r\n    grid-column-start: 2;\r\n    width: 100%;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__right__items {\r\n    max-width: fit-content;\r\n    grid-column-start: 3;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__Grid h1 {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .contacts__right__items h1 {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .contacts__Grid p {\r\n    font-size: 17px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Grid img {\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(320px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 68.6%;\r\n    color: white;\r\n    position: static;\r\n    z-index: 100;\r\n    bottom: 0;\r\n    left: 15.7%;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1025px) and (max-width: 1440px) {\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding-top: 0px;\r\n    padding-top: 2.5em;\r\n    align-content: center;\r\n    align-items: end;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 2;\r\n    max-width: 80% !important;\r\n  }\r\n\r\n  .contacts__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 80%;\r\n    height: 75%;\r\n    position: relative;\r\n    left: 0;\r\n    top: 7.5%;\r\n    color: white;\r\n    justify-items: right;\r\n    align-items: center;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__items__grid {\r\n    grid-column: 2 / 5;\r\n    display: grid;\r\n    grid-gap: 10px;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    max-width: 80%;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .contacts__contacts__Grid {\r\n    display: inline-grid;\r\n    grid-template-columns: auto auto auto;\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__left__items {\r\n    max-width: 100%;\r\n    grid-column-start: 1;\r\n    width: 100%;\r\n    justify-self: right;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__middle__items {\r\n    max-width: 100%;\r\n    grid-column-start: 2;\r\n    width: 100%;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__right__items {\r\n    max-width: fit-content;\r\n    grid-column-start: 3;\r\n    position: static;\r\n  }\r\n\r\n  .contacts__Grid h1 {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .contacts__right__items h1 {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .contacts__Grid p {\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Grid img {\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(320px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 80%;\r\n    color: white;\r\n    position: static;\r\n    z-index: 100;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 769px) and (max-width: 1024px) {\r\n  #section {\r\n    background-image: var(--img);\r\n    background-size: contain;\r\n    background-position: bottom left;\r\n    background-repeat: no-repeat;\r\n    position: relative;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    align-items: end;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    margin-top: 2.5em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    justify-content: left;\r\n    position: relative;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__mobile__test {\r\n    grid-column: 1 / 3;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .contacts__Grid__mobile h1 {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .contacts__Grid__mobile p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Mobile__icons {\r\n    grid-column: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    width: 100%;\r\n  }\r\n\r\n  .contacts__Mobile__icons h1 {\r\n    margin-right: 1em;\r\n  }\r\n\r\n  .contacts__Mobile__icons img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__middle__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__right__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left h1 {\r\n    position: relative;\r\n  }\r\n\r\n  .yaya {\r\n    justify-self: right;\r\n  }\r\n  .yaya img {\r\n    padding: 0.5em 0 0.5em 0;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 1em 0 1em 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: fixed;\r\n    bottom: 1em;\r\n    left: 5%;\r\n  }\r\n\r\n  .footer__mobile__contacts__img {\r\n    max-height: 34.0333px;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile {\r\n    display: grid;\r\n    align-items: center;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile p {\r\n    justify-self: left;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 426px) and (max-width: 768px) {\r\n  #section {\r\n    background-image: var(--img);\r\n    background-size: contain;\r\n    background-position: bottom left;\r\n    background-repeat: no-repeat;\r\n    position: relative;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    align-items: end;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    margin-top: 2.5em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    justify-content: left;\r\n    position: relative;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__mobile__test {\r\n    grid-column: 1 / 3;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .contacts__Grid__mobile h1 {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .contacts__Grid__mobile p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Mobile__icons {\r\n    grid-column: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    width: 100%;\r\n  }\r\n\r\n  .contacts__Mobile__icons h1 {\r\n    margin-right: 1em;\r\n  }\r\n\r\n  .contacts__Mobile__icons img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__middle__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__right__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left h1 {\r\n    position: relative;\r\n  }\r\n\r\n  .yaya {\r\n    justify-self: right;\r\n  }\r\n  .yaya img {\r\n    padding: 0.5em 0 0.5em 0;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 1em 0 1em 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: fixed;\r\n    bottom: 1em;\r\n    left: 5%;\r\n  }\r\n\r\n  .footer__mobile__contacts__img {\r\n    max-height: 34.0333px;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile {\r\n    display: grid;\r\n    align-items: center;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile p {\r\n    justify-self: left;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 376px) and (max-width: 425px) {\r\n  #section {\r\n    background-image: var(--img);\r\n    background-size: contain;\r\n    background-position: bottom left;\r\n    background-repeat: no-repeat;\r\n    position: relative;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    align-items: end;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    margin-top: 2.5em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    justify-content: left;\r\n    position: relative;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__mobile__test {\r\n    grid-column: 1 / 3;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .contacts__Grid__mobile h1 {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .contacts__Grid__mobile p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Mobile__icons {\r\n    grid-column: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    width: 100%;\r\n  }\r\n\r\n  .contacts__Mobile__icons h1 {\r\n    margin-right: 1em;\r\n  }\r\n\r\n  .contacts__Mobile__icons img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__middle__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__right__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left h1 {\r\n    position: relative;\r\n  }\r\n\r\n  .yaya {\r\n    justify-self: right;\r\n  }\r\n  .yaya img {\r\n    padding: 0.5em 0 0.5em 0;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 1em 0 1em 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: fixed;\r\n    bottom: 1em;\r\n    left: 5%;\r\n  }\r\n\r\n  .footer__mobile__contacts__img {\r\n    max-height: 34.0333px;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile {\r\n    display: grid;\r\n    align-items: center;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile p {\r\n    justify-self: left;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 321px) and (max-width: 375px) {\r\n  #section {\r\n    background-image: var(--img);\r\n    background-size: contain;\r\n    background-position: bottom left;\r\n    background-repeat: no-repeat;\r\n    position: relative;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    align-items: end;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    margin-top: 2.5em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    justify-content: left;\r\n    position: relative;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__mobile__test {\r\n    grid-column: 1 / 3;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .contacts__Grid__mobile h1 {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .contacts__Grid__mobile p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Mobile__icons {\r\n    grid-column: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    width: 100%;\r\n  }\r\n\r\n  .contacts__Mobile__icons h1 {\r\n    margin-right: 1em;\r\n  }\r\n\r\n  .contacts__Mobile__icons img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__middle__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__right__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left h1 {\r\n    position: relative;\r\n  }\r\n\r\n  .yaya {\r\n    justify-self: right;\r\n  }\r\n  .yaya img {\r\n    padding: 0.5em 0 0.5em 0;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 1em 0 1em 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: fixed;\r\n    bottom: 1em;\r\n    left: 5%;\r\n  }\r\n\r\n  .footer__mobile__contacts__img {\r\n    max-height: 34.0333px;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile {\r\n    display: grid;\r\n    align-items: center;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile p {\r\n    justify-self: left;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 320px) {\r\n  #section {\r\n    background-image: var(--img);\r\n    background-size: contain;\r\n    background-position: bottom left;\r\n    background-repeat: no-repeat;\r\n    position: relative;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__footer__contacts {\r\n    display: none;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    align-items: end;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n  }\r\n\r\n  .contacts__Grid__mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    margin-top: 2.5em;\r\n    padding-bottom: 2.5em;\r\n    color: white;\r\n    justify-content: left;\r\n    position: relative;\r\n    position: relative;\r\n    z-index: 101;\r\n  }\r\n\r\n  .contacts__mobile__test {\r\n    grid-column: 1 / 3;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .contacts__Grid__mobile h1 {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .contacts__Grid__mobile p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .contacts__Mobile__icons {\r\n    grid-column: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    width: 100%;\r\n  }\r\n\r\n  .contacts__Mobile__icons h1 {\r\n    margin-right: 1em;\r\n  }\r\n\r\n  .contacts__Mobile__icons img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__middle__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    padding-bottom: 2.5em;\r\n    position: relative;\r\n    left: 0;\r\n  }\r\n\r\n  .contacts__left__items__mobile img {\r\n    justify-self: end;\r\n  }\r\n\r\n  .contacts__left__items__mobile p {\r\n    justify-self: left;\r\n    grid-column: 2 / 3 !important;\r\n  }\r\n\r\n  .contacts__right__items__mobile {\r\n    grid-column: 1 / 3;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile__left h1 {\r\n    position: relative;\r\n  }\r\n\r\n  .yaya {\r\n    justify-self: right;\r\n  }\r\n  .yaya img {\r\n    padding: 0.5em 0 0.5em 0;\r\n  }\r\n\r\n  .grid-container__footer__mobile__contacts {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 1em 0 1em 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: fixed;\r\n    bottom: 1em;\r\n    left: 5%;\r\n  }\r\n\r\n  .footer__mobile__contacts__img {\r\n    max-height: 34.0333px;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile {\r\n    display: grid;\r\n    align-items: center;\r\n  }\r\n\r\n  .contacts__contacts__item__mobile p {\r\n    justify-self: left;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
